module.exports = __webpack_public_path__ + "static/media/example-of-file-user-passport.8eafd078.pdf";